//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "./tableOfContentsView",
  "./tableOfContentsModel",
  "./tableOfContentsList/tableOfContentsListModule",
  "./tableOfContentsEntry/tableOfContentsEntryModule",
], function (
  Marionette,
  Messenger,
  Backbone,
  TableOfContentsView,
  TableOfContentsModel,
  TableOfContentsListModule,
  TableOfContentsEntryModule,
) {
  "use strict";

  var TableOfContentsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tableOfContents";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      var activeKb = Messenger.reqres.request("active:kb");
      Backbone.history.navigate(activeKb + "/authoringAdmin/tableOfContents");
      this.tableOfContentsCollection = new TableOfContentsModel.tableOfContentsCollection();
      this.tableOfContentsCollection.kbId = activeKb;
      this.tableOfContentsCollection.fetch();
      this.layout = new TableOfContentsView.tableOfContentsView({
        model: this.tableOfContentsCollection,
      });
      this.list = this.addSubModule(
        new TableOfContentsListModule({
          namespace: "tableOfContents",
          region: this.layout.tableOfContentsList,
        }),
      );
      this.entry = this.addSubModule(
        new TableOfContentsEntryModule({
          region: this.layout.tableOfContentsEntry,
        }),
      );

      this.layout.on("add:tableOfContents", this._onAddTableOfContents, this);
      this.layout.on("show", this._showSubViews, this);

      this.tableOfContentsCollection.onSynced(function () {
        this.showRegion(this.layout);
      }, this);
    },
    _onAddTableOfContents: function () {
      var _this = this;
      Messenger.save(function (success) {
        if (success) {
          var tableOfContents = _this.tableOfContentsCollection.addItem();
          _this.list.selectItem(tableOfContents);
        }
      });
    },
    _onDeleteTableOfContents: function (model) {
      model.deleteModel();
      this.entry.hide();
    },
    _onTableOfContentsSelected: function (model) {
      this.entry.show(model);
    },
    _showSubViews: function () {
      this.list.show(this.tableOfContentsCollection);
    },
    _setUpVents: function () {
      Messenger.vent.on("delete:tableOfContents", this._onDeleteTableOfContents, this);
      //Show the categories admin screen
      Messenger.vent.on("show:authoring:admin:tableOfContents", this.show, this);
      //show the module
      Messenger.vent.on("show:kb:admin:tableOfContents", this.show, this);
      Messenger.vent.on(
        "tableOfContents:list:item:selected",
        this._onTableOfContentsSelected,
        this,
      );
    },
  });

  return TableOfContentsController;
});
